import { render, staticRenderFns } from "./PanelsToggle.vue?vue&type=template&id=404a90eb"
import script from "./PanelsToggle.vue?vue&type=script&lang=js"
export * from "./PanelsToggle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports